export const IMAGE_FALLBACK =
  "https://img.abiosgaming.com/other/New-Abios-Place-Holder.png"
